import { TReduxActions } from '../../types/redux';
import { IService } from '../../types/services';

export function servicesReducer(state: IService[] = [], action: TReduxActions): IService[] {
  switch (action.type) {
    default:
      return state;
  }
}
